import React from 'react'
import { Col, Input } from 'core/components/ui'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { getMileageUnit } from 'core/utils/cultures/unit'
import { isMobile } from 'react-device-detect'
import { InputWrapper, InterTitle } from '../../styled'

const MAX_MILEAGE = 999999

const FormItem = ({ form, vehicle, setTradeIn, tradeIn }) => {
  const intl = useIntl()
  const { getFieldDecorator } = form
  const { mileage } = vehicle

  const convertToInt = value => {
    const valueWithoutSpace = value.replace(/\D+/g, '')
    const number = parseInt(valueWithoutSpace || 0, 10)
    return number
  }
  const handleChange = e => {
    const { value } = e.target
    const number = convertToInt(value)
    if (Number.isNaN(number) || number > MAX_MILEAGE) {
      return
    }

    const extendedVehicle = { ...vehicle, mileage: number }
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} lg={{ span: 12 }}>
      <InterTitle id="globaldealer-title-11">
        <FormattedMessage id="tradeIn-historical-subtitle-1" />
      </InterTitle>
      <InputWrapper>
        <Col xs={{ span: 16 }} lg={{ span: 4 }}>
          {getFieldDecorator('mileage', {
            /* eslint-disable */
            rules: [{ required: true, type: 'regexp', pattern: new RegExp('[0-9 .,]+/g') }],
            normalize: value => {
              const number = convertToInt(value)
              let clonedValue = value
              if (number > MAX_MILEAGE) {
                clonedValue = mileage
              }
              if (isNaN(clonedValue) || typeof clonedValue === 'string') {
                clonedValue = clonedValue.replace(/\D+/g, '')
                clonedValue = Number(clonedValue)
              }
              return intl.formatNumber(clonedValue)
            },
            initialValue: mileage ? intl.formatNumber(mileage) : mileage
          })(
            <Input
              inputMode="numeric"
              onChange={handleChange}
              style={{
                width: isMobile ? '100%' : '150px',
                margin: '10px 12px 10px 0',
                minWidth: '150px'
              }}
              suffix={getMileageUnit()}
            />
          )}
        </Col>
      </InputWrapper>
    </Col>
  )
}

FormItem.propTypes = {
  form: PropTypes.any.isRequired,
  vehicle: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: PropTypes.any.isRequired
}

export default { FormItem }
